<app-navbar></app-navbar>

<router-outlet></router-outlet>
<ngx-spinner *ngIf="!ischeckinThorughCard" bdColor="rgba(0,0,0,0.8)" size="medium" color="#fff" type="ball-fussion">
  <p style="color: white">  {{'generic_text.processing'| translate}} </p>
</ngx-spinner>
<ngx-spinner *ngIf="ischeckinThorughCard"
             bdColor="rgba(0,0,0,0.8)"
             size="medium"
             color="#fff"
             type="ball-fussion">
  <p class="scanText">
    {{'generic_text.scanning'| translate}}
  </p>
</ngx-spinner>

